import { render, staticRenderFns } from "./QuotationModelCreate.vue?vue&type=template&id=38b60d72&scoped=true"
import script from "./QuotationModelCreate.vue?vue&type=script&lang=js"
export * from "./QuotationModelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b60d72",
  null
  
)

export default component.exports